<section role="region" class="cej-v2-allocation-bg">
  <div class="cej-v2-allocation">
    <img
      class="cej-v2-allocation__img"
      [src]="imgSrc | imaginarySrc: 1:527"
      [srcset]="imgSrc | imaginarySrc: 4:527"
      alt=""
    />
    <div>
      <h3 class="cej-v2-allocation__title">Est-ce que je peux bénéficier de l&apos;allocation&nbsp;?</h3>
      <p class="cej-v2-allocation__subtitle">
        Je perçois une allocation pouvant aller jusqu&apos;à 500 euros par mois en fonction de&nbsp;:
      </p>
      <ul class="proposal-list">
        <li>
          <em class="proposal-list__emphasis">Mon âge</em>
        </li>
        <li>
          <em class="proposal-list__emphasis">Mes ressources</em>
        </li>
        <li>
          <em class="proposal-list__emphasis">Mon statut </em>
          (si je suis détaché fiscalement ou si je suis rattaché fiscalement à un foyer aux revenus modestes)
        </li>
        <li>
          Du respect de mes
          <em class="proposal-list__emphasis"> engagements</em>
        </li>
      </ul>
    </div>
  </div>
</section>
